import { Routes, RouterModule, Route } from '@angular/router';
import { DeactivateGuard }  from './deactivate-guard';
import { ActivateGuard }  from './activate-guard';

import { LMDefaultRouteComponent } from '@routes/lm-default-route.component';
import { LMFormComponent } from '@form/lm-form.component';
import { LMHomePageComponent } from '@home/lm-home-page.component';
import { LMHomeRouteComponent } from '@routes/lm-home-route.component';
import { LMHtmlPageComponent } from '@html/lm-html-page.component';
import { LMListComponent } from '@list/lm-list.component';
import { LMPageComponent } from '@page/lm-page.component';
import { LMSuiteHomeComponent } from '@home/lm-suite-home.component';
import { LMAuditLogComponent } from '@auditlog/lm-audit-log.component';
import { LMNavigationComponent } from '@navigation/lm-navigation.component';
import { LMActionComponent } from '@action/lm-action.component';
import { LMReportsCatalogComponent } from '@report/index';
import {LMDrillAroundComponent} from "@app/components";

const indexRoute: Route = {
  path: '',
  component: LMHomeRouteComponent
};

const fallbackRoute: Route = {
  path: '**',
  component: LMDefaultRouteComponent
};

const appRoutes: Routes = [
  { path: ':dataArea/web/home', component: LMSuiteHomeComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/web/land/default', component: LMSuiteHomeComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/:webApp/report/catalog', component: LMReportsCatalogComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/:webApp/drill/:resourceId', component: LMDrillAroundComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },


  /***************************************************************
   * Special route definition to load url to routerOutlet
   **************************************************************/
  // runGuardsAndResolvers is enabled to allow search params to trigger the route guards to be run.
  { path: ':dataArea/:webApp/html/url', component: LMHtmlPageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard], runGuardsAndResolvers: 'always' },

  /***************************************************************
   * Standard dataarea route definitions
   **************************************************************/
  // runGuardsAndResolvers on lists is enabled to allow the list to be reloaded after a personalization since without the setting same urls are ignored. Vonny fix for LMCLIENT-22265
  { path: ':dataArea/:webApp/list/:resourceId',  component: LMListComponent,     canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard], runGuardsAndResolvers: 'always'},
  { path: ':dataArea/:webApp/form/:resourceId',  component: LMFormComponent,     canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/:webApp/page/:resourceId',  component: LMPageComponent,     canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/:webApp/audit/:resourceId', component: LMAuditLogComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },

  { path: ':dataArea/:webApp/home',              component: LMHomePageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  // runGuardsAndResolvers is enabled to allow search params to trigger the route guards to be run.
  { path: ':dataArea/:webApp/html/:resourceId',  component: LMHtmlPageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard], runGuardsAndResolvers: 'always' },
  { path: ':dataArea/:webApp/land/:resourceId',  component: LMHtmlPageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/:webApp/widgets/:resourceId/:resourceId',  component: LMHtmlPageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },

  { path: ':dataArea/:webApp/navigation/:resourceId',  component: LMNavigationComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':dataArea/:webApp/action/:resourceId',  component: LMActionComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },

  /***************************************************************
   * GEN dataarea route definitions
   **************************************************************/
  { path: ':webApp/list/:resourceId',  component: LMListComponent,     canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':webApp/form/:resourceId',  component: LMFormComponent,     canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':webApp/page/:resourceId',  component: LMPageComponent,     canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':webApp/audit/:resourceId', component: LMAuditLogComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },

  { path: ':webApp/home',              component: LMHomePageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':webApp/html/:resourceId',  component: LMHtmlPageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':webApp/land/:resourceId',  component: LMHtmlPageComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },

  { path: ':webApp/navigation/:resourceId',  component: LMNavigationComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },
  { path: ':webApp/report/catalog', component: LMReportsCatalogComponent, canActivate: [ActivateGuard], canDeactivate: [DeactivateGuard] },

  indexRoute,
  fallbackRoute
];

export const appRoutingProviders: any[] = [];               //https://ngrefs.com/v8/router/extraoptions-interface
export const appRouting = RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload', enableTracing: false });
